function Pause({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || '24'} height=${dimensions || '24'} viewBox="-3 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="m4.801 23.999h-3.6c-.662-.001-1.199-.537-1.2-1.2v-21.6c0-.663.537-1.2 1.2-1.201h3.6c.662.001 1.199.537 1.2 1.2v21.6c0 .663-.537 1.2-1.2 1.201z" fill=${`"${col}"`}/>
      <path d="m16.8 23.999h-3.6c-.663 0-1.2-.537-1.2-1.2v-21.6-.001c0-.663.537-1.2 1.2-1.2h3.6c.663 0 1.2.537 1.2 1.2v21.6c0 .663-.537 1.2-1.2 1.2z" fill=${`"${col}"`}/>
    </svg>
  `;

  return baseXml;
}

export default Pause;
